import { studentBirthdayColumn } from 'Src/components/StudentBirthday/StudentBirthday';
import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { FILTER_TYPE, FIRST_PAGE, DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import { CELL_ACTION_ICON } from 'Src/consts/cell';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { Loader } from 'Src/components/Loader/Loader';
import { StudentForm } from 'Src/components/StudentForm/StudentForm';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { getGender } from 'Src/helpers/accessor/accessor';
import {
  getSchoolTournamentTeamPlayers,
  getSchoolTournamentTeamPlayersCount,
  getAllSchoolTournamentTeamPlayers
} from 'Src/helpers/service/admin/tournamentTeamPlayers';
import { removeSchoolEventTeamPlayer } from 'Src/helpers/service/admin/tournamentTeams';
import { getSelectOptionForAge, getSelectOptionForGender } from 'Src/helpers/table/select';
import { removeSchoolEventIndividualPlayer } from 'Src/helpers/service/admin/tournamentTeams';
import { updateSchoolEventIndividualsBatch } from 'Src/helpers/service/admin/schoolEventIndividuals';
import { updateSchoolEventTeamPlayersBatch } from 'Src/helpers/service/admin/event';
import { addSchoolEventTeam } from 'Src/helpers/service/admin/tournamentTeams';
import { getTeamPlayerAgesGroup } from 'Src/helpers/accessor/accessor';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import { getSchoolEvent } from 'Src/helpers/service/admin/event';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { updateSchoolTournamentTeamPlayersBatch } from 'Src/helpers/service/admin/tournamentTeamPlayers';
import { IndividualTournamentTeamPlayer, TournamentTeamPlayerEvent } from 'Src/models/tournamentTeamPlayer';
import { SchoolEvent } from 'Src/models/event';
import { Tournament } from 'Src/models/tournament';
import { SchoolForm } from 'Src/models/form';
import { getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { addSchoolStudent, searchSchoolStudents, updateSchoolStudent } from 'Src/helpers/service/admin/students';
import { SchoolStudent } from 'Src/models/schoolStudent';
import { AddPlayerToEventForm } from './AddPlayerToEventForm';
import '../../Invites/SchoolInvitesHub.scss';
import '../TournamentEvents.css';
import './TournamentTeamPlayers.scss';

const getApiErrorMessage = (error: any): string =>
  propz.get(error, ['response', 'data', 'details', 'text'], '') ||
  propz.get(error, ['response', 'data', 'message'], '') ||
  error?.message ||
  'Unable to update event allocations. Please try again.';

const getTournamentPlayerEventActionsCell = (player, options, onIconClick) => (
  <td className="tournamentTeamPlayersModern__eventActions">
    <div className="tournamentTeamPlayersModern__eventActionsLayout">
      {!options.isRosterReadOnly && (
        <button
          type="button"
          className="tournamentTeamPlayersModern__allocateIcon"
          title="Allocate to events"
          aria-label={`Allocate ${getFullName(player)} to events`}
          onClick={event => {
            event.stopPropagation();
            onIconClick({ currentPlayer: player }, CELL_ACTION_ICON.ADD_TO_EVENT);
          }}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3.5" y="5" width="13" height="15" rx="2" />
            <path d="M7 3v4m6-4v4M3.5 9.5h13M19 14v7m-3.5-3.5h7" />
          </svg>
        </button>
      )}
      <div className="tournamentTeamPlayersModern__eventDetails">
        <div className="tournamentTeamPlayersModern__eventChips">
          {(player.events || []).map(event => {
            const name =
              String(event.shortDescription || '').trim() ||
              propz.get(event, ['generatedNames', 'official'], 'Tournament event');
            return (
              <span key={event.id}>
                {name}
                {!options.isRosterReadOnly && (
                  <button
                    type="button"
                    title={`Remove ${name}`}
                    aria-label={`Remove ${name}`}
                    onClick={buttonEvent => {
                      buttonEvent.stopPropagation();
                      onIconClick({ currentPlayer: player, currentEvent: event }, CELL_ACTION_ICON.REMOVE_FROM_EVENT);
                    }}
                  >
                    <svg viewBox="0 0 16 16" aria-hidden="true">
                      <path d="M4.5 4.5l7 7m0-7l-7 7" />
                    </svg>
                  </button>
                )}
              </span>
            );
          })}
        </div>
        {player.isAtParticipationLimit && (
          <span className="tournamentTeamPlayersModern__limitBadge" title={player.participationLimitTitle}>
            Limit reached
          </span>
        )}
      </div>
    </div>
  </td>
);

const getTournamentPlayerRowActionsCell = (player, options, onIconClick) => (
  <td className="tournamentTeamPlayersModern__rowActions">
    <button
      type="button"
      title="Edit player"
      aria-label={`Edit ${getFullName(player)}`}
      onClick={event => {
        event.stopPropagation();
        onIconClick({ currentPlayer: player }, CELL_ACTION_ICON.EDIT);
      }}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 20h4L19 9l-4-4L4 16v4zM13.5 6.5l4 4" />
      </svg>
    </button>
    <button
      type="button"
      className="isDanger"
      title="Remove from team"
      aria-label={`Remove ${getFullName(player)} from team`}
      onClick={event => {
        event.stopPropagation();
        onIconClick({ currentPlayer: player }, CELL_ACTION_ICON.REMOVE_FROM_TEAM);
      }}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" />
      </svg>
    </button>
  </td>
);

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: IndividualTournamentTeamPlayer[];
  currentPage: number;
  selectedItems: IndividualTournamentTeamPlayer[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  isLoading: boolean;
  total: number;
  basePath: string;
  isSelectAllChecked: boolean;
  modalText: string;
  isEditTeamModalOpen: boolean;
  isRemoveFromEventConfirmationModalOpen: boolean;
  isRemoveFromTeamConfirmationModalOpen: boolean;
  isRemoveFromTeamProhibitionModalOpen: boolean;
  isAddPlayerToEventModalOpen: boolean;
  forms: SchoolForm[];
  tournament?: Tournament;

  eventIdToRemove: string;
  currentPlayer: IndividualTournamentTeamPlayer | undefined;
  isAskToRemovePlayerFromEvent: boolean;

  errorMessage: string;
  actionErrorMessage: string;

  isEditStudentModalOpen: boolean;
  studentToEdit: IndividualTournamentTeamPlayer | null;
  isAddStudentModalOpen: boolean;
  studentToAdd: any;
  identicalStudents: SchoolStudent[];
  similarStudents: SchoolStudent[];
}

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  studentBirthdayColumn,
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Age group',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getTeamPlayerAgesGroup
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  },
  {
    text: 'Event actions',
    field: 'eventsActions',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getTournamentPlayerEventActionsCell
  },
  {
    text: 'Actions',
    field: 'actions',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getTournamentPlayerRowActionsCell,
    align: 'right'
  }
];

export class TournamentTeamPlayers extends Component<Props, State> {
  private addPlayerToEventFormRef = React.createRef<AddPlayerToEventForm>();

  isRosterReadOnly = (): boolean => {
    const { tournament } = this.state;
    const routeReadOnly = propz.get(this.props.location, ['state', 'isRosterReadOnly'], false);
    const activeSchoolId = this.props.user.activeSchoolId;
    return Boolean(
      routeReadOnly ||
        (tournament &&
          tournament.isReadOnly &&
          String(tournament.schoolId || '') !== String(activeSchoolId || ''))
    );
  };

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filters: {},
      isDataFiltered: false,
      isLoading: false,
      total: 0,
      basePath: '',
      isSelectAllChecked: false,
      modalText: '',
      isEditTeamModalOpen: false,
      isRemoveFromEventConfirmationModalOpen: false,
      isRemoveFromTeamConfirmationModalOpen: false,
      isRemoveFromTeamProhibitionModalOpen: false,
      isAddPlayerToEventModalOpen: false,
      forms: [],
      tournament: undefined,
      eventIdToRemove: '',
      currentPlayer: undefined,
      isAskToRemovePlayerFromEvent: false,
      errorMessage: '',
      actionErrorMessage: '',
      isEditStudentModalOpen: false,
      studentToEdit: null,
      isAddStudentModalOpen: false,
      studentToAdd: undefined,
      identicalStudents: [],
      similarStudents: []
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  setAdditionalItems() {
    const { user } = this.props;

    return Promise.all([getAllForms(user), getTournament(user, this.getTournamentId())]).then(([forms, tournament]) => {
      const isRosterReadOnly = Boolean(
        propz.get(this.props.location, ['state', 'isRosterReadOnly'], false) ||
          (tournament.isReadOnly && String(tournament.schoolId || '') !== String(user.activeSchoolId || ''))
      );
      this.setState({
        forms,
        tournament
      });
      window.dispatchEvent(
        new CustomEvent('sit:topbar-breadcrumb', {
          detail: `${tournament.name} / Teams / ${propz.get(this.props.location, ['state', 'teamName'], '') ||
            'Team'} / ${isRosterReadOnly ? 'View participants & allocations' : 'Allocate to events'}`
        })
      );
    });
  }

  componentWillUnmount() {
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;
    const { forms } = this.state;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isDataFiltered = isFilterExist2(filters);

    const options = {
      forms
    };

    const where = getServerFieldSectionWhere(filters, options);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    this.setState({
      isLoading: true
    });

    const getItemsPromise = getSchoolTournamentTeamPlayers(user, tournamentId, teamId, serverQueryFilter, true);
    const getItemsCountPromise = getSchoolTournamentTeamPlayersCount(user, tournamentId, teamId, where);

    return Promise.all([getItemsPromise, getItemsCountPromise]).then(([items, countObj]) => {
      const tournament = this.state.tournament;
      const enforceLimits = propz.get(tournament, ['isEventParticipantLimitEnforced'], true) !== false;
      const individualLimit = Number(propz.get(tournament, ['maxIndividualEventsPerStudent'], 0));
      const relayLimit = Number(propz.get(tournament, ['maxRelayEventsPerStudent'], 0));
      const decoratedItems = items.map(player => {
        const events = player.events || [];
        const isRelayEvent = event => Boolean(event.teamBased || propz.get(event, ['sport', 'isRelay'], false));
        const individualCount = events.filter(event => !isRelayEvent(event)).length;
        const relayCount = events.filter(isRelayEvent).length;
        const reached: string[] = [];
        if (enforceLimits && individualLimit > 0 && individualCount >= individualLimit) {
          reached.push(`${individualCount}/${individualLimit} individual events`);
        }
        if (enforceLimits && relayLimit > 0 && relayCount >= relayLimit) {
          reached.push(`${relayCount}/${relayLimit} relay events`);
        }
        return {
          ...player,
          isAtParticipationLimit: reached.length > 0,
          participationLimitTitle: reached.length ? `Participation limit reached: ${reached.join(', ')}` : ''
        };
      });
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: decoratedItems,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const search = propz.get(state, ['search'], '');
    const prevRoutePath = propz.get(state, ['prevRoutePath'], '');
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: '/tournaments/teams',
      search: `tournamentId=${tournamentId}`,
      state: { ...(state as any), search, prevRoutePath, tournamentId }
    });
  };

  getTournamentId(): string {
    const { location } = this.props;
    const search = parse(location.search);
    const tournamentId = String(search.tournamentId || propz.get(location, ['state', 'tournamentId'], '') || '');
    return tournamentId === 'undefined' || tournamentId === 'null' ? '' : tournamentId;
  }

  getTeamId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const teamId = search.teamId;
    return teamId;
  }

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    this.setState(prevState => {
      return {
        isShowFilter: !prevState.isShowFilter
      };
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (options && options.modernMultiValue) {
      nextFilters = { ...nextFilters, [filterField]: filterValue };
    } else if (options && options.modernRange) {
      nextFilters = { ...nextFilters, [filterField]: options.modernRange };
    } else if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      if (!filter) return;
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { location } = this.props;
    const { state } = location;
    const locationSearch = propz.get(state, ['search'], '');
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    const teamName = propz.get(location, ['state', 'teamName'], '');

    const { history } = this.props;
    const { basePath } = this.state;
    const teamId = this.getTeamId();
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}&${search.join('&')}`,
      state: { search: locationSearch, teamName }
    });
  };

  onClearFilterClick = (): void => {
    const { location } = this.props;
    const { state } = location;
    const locationSearch = propz.get(state, ['search'], '');

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: getFilters2(COLUMNS, {})
    });

    const { history } = this.props;
    const { basePath } = this.state;
    const teamId = this.getTeamId();
    const tournamentId = this.getTournamentId();

    const teamName = propz.get(location, ['state', 'teamName'], '');

    history.push({
      pathname: basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}`,
      state: { search: locationSearch, teamName }
    });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false, filters: getFilters2(COLUMNS, parse(this.props.history.location.search)) });
  };

  onToolbarSearchClear = (): void => {
    this.setState(prevState => ({ filters: { ...prevState.filters, name: '' } }), this.onApplyFilterClick);
  };

  onCellIconClick = (
    data: { currentPlayer: IndividualTournamentTeamPlayer; currentEvent?: TournamentTeamPlayerEvent },
    cell: string
  ) => {
    const { isAskToRemovePlayerFromEvent } = this.state;
    const { currentPlayer, currentEvent } = data;
    const playerFullName = getFullName(currentPlayer);

    switch (true) {
      case cell === CELL_ACTION_ICON.ADD_TO_EVENT:
        this.setState({
          currentPlayer
        });

        this.openAddPlayerToEventModal();
        break;

      case cell === CELL_ACTION_ICON.REMOVE_FROM_EVENT:
        if (!currentEvent) break;

        const { id } = currentEvent;
        const eventName = propz.get(currentEvent, ['generatedNames', 'official'], '');

        this.setState(
          {
            modalText: `${playerFullName} will be removed from ${eventName}. Are you sure?`,
            eventIdToRemove: id,
            currentPlayer
          },
          () => {
            isAskToRemovePlayerFromEvent ? this.removePlayerFromEvent() : this.openRemoveFromEventConfirmationModal();
          }
        );
        break;

      case cell === CELL_ACTION_ICON.REMOVE_FROM_TEAM:
        const { events } = currentPlayer;
        const IsEventsExist = events.length > 0;

        this.setState(
          {
            modalText: IsEventsExist ? '' : `${playerFullName} will be removed from the team. Are you sure?`,
            currentPlayer
          },
          () => {
            IsEventsExist ? this.openRemoveFromTeamProhibitionModal() : this.openRemoveFromTeamConfirmationModal();
          }
        );

        break;

      case cell === CELL_ACTION_ICON.EDIT:
        this.handleEditClick(currentPlayer);
        break;
    }
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;
    const { history } = this.props;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;
    const { history } = this.props;

    if (currentPage !== FIRST_PAGE) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters, forms } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const options = {
      forms
    };

    const where = getServerFieldSectionWhere(filters, options);

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    getAllSchoolTournamentTeamPlayers(user, tournamentId, teamId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  removePlayerFromEvent = (): void => {
    const { user } = this.props;
    const { eventIdToRemove, currentPlayer } = this.state;
    if (!currentPlayer) return;
    const removePlayerId = currentPlayer.userId;

    this.setState({
      isLoading: true
    });

    getSchoolEvent(user, eventIdToRemove)
      .then(schoolEvent => {
        const isRelay = propz.get(schoolEvent, ['sport', 'isRelay'], false);

        const { players } = schoolEvent;
        const foundPlayer = players.find(player => player.userId === removePlayerId);

        if (!foundPlayer) return Promise.reject('Player not found');

        const teamId = (foundPlayer as any).teamId;
        const playerId = (foundPlayer as any)._id;

        return isRelay
          ? removeSchoolEventTeamPlayer(user, eventIdToRemove, teamId, playerId)
          : removeSchoolEventIndividualPlayer(user, eventIdToRemove, playerId);
      })
      .then(() => {
        return this.setItems();
      })
      .then(() => {
        const { items, selectedItems } = this.state;

        const updatedSelectedItems = items.filter(item => {
          return selectedItems.some(selectedItem => selectedItem.id === item.id);
        });

        this.setState({
          selectedItems: [],
          isSelectAllChecked: false,
          isRemoveFromEventConfirmationModalOpen: false,
          modalText: '',
          isLoading: false,
          currentPlayer: undefined
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isRemoveFromEventConfirmationModalOpen: false,
          actionErrorMessage: getApiErrorMessage(error)
        });
      });
  };

  addPlayerToEvent = (
    assignments: {
      event: SchoolEvent;
      students: IndividualTournamentTeamPlayer[];
      playersToReplace: { eventId: string; playerId: string }[];
    }[]
  ): void => {
    this.setState({ isLoading: true });

    const { user } = this.props;

    const removePromises = assignments.reduce((acc: Promise<any>[], { playersToReplace }) => {
      return [
        ...acc,
        ...playersToReplace.map(({ eventId, playerId }) => removeSchoolEventIndividualPlayer(user, eventId, playerId))
      ];
    }, []);

    const addPromises = assignments.reduce((acc: Promise<any>[], { event, students }) => {
      const { id: eventId, ages, gender } = event;
      const studentData = students.map(s => ({
        permissionId: s.permissionId,
        userId: s.userId
      }));

      const isRelay = propz.get(event, ['sport', 'isRelay'], false);

      if (isRelay) {
        const teamsData = propz.get(event, ['teamsData'], []);
        const schoolTeam = teamsData.find((team: any) => team.schoolId === user.activeSchoolId);
        const isSchoolTeamExist = typeof schoolTeam !== 'undefined';
        const teamToAdd = { ages, gender, players: studentData };

        return [
          ...acc,
          isSchoolTeamExist
            ? updateSchoolEventTeamPlayersBatch(user, eventId, schoolTeam.id, { add: studentData })
            : addSchoolEventTeam(user, eventId, teamToAdd)
        ];
      } else {
        return [...acc, updateSchoolEventIndividualsBatch(user, eventId, { add: studentData })];
      }
    }, []);

    Promise.all(removePromises)
      .then(() => Promise.all(addPromises))
      .then(() => this.setItems())
      .then(() => {
        this.setState({
          selectedItems: [],
          isSelectAllChecked: false,
          isLoading: false,
          isAddPlayerToEventModalOpen: false,
          currentPlayer: undefined
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isAddPlayerToEventModalOpen: false,
          actionErrorMessage: getApiErrorMessage(error)
        });
      });
  };

  renderActionErrorModal = () => {
    const { actionErrorMessage } = this.state;
    if (!actionErrorMessage) return null;

    const close = () => this.setState({ actionErrorMessage: '' });
    return (
      <SimpleModal
        isOpen
        showHeader={false}
        showFooter={false}
        customClass="tournamentRemovalModal"
        dialogStyle={{ maxWidth: 520 }}
        onBackdropClick={close}
      >
        <div className="tournamentRemovalModal__content">
          <header>
            <span className="tournamentRemovalModal__icon" aria-hidden="true">!</span>
            <div>
              <h2>Unable to update allocations</h2>
              <p>Your changes were not saved.</p>
            </div>
          </header>
          <div className="tournamentRemovalModal__body">
            <p>{actionErrorMessage}</p>
          </div>
          <footer>
            <button type="button" onClick={close}>OK</button>
          </footer>
        </div>
      </SimpleModal>
    );
  };

  handleEditClick = (player: IndividualTournamentTeamPlayer) => {
    this.setState({
      isEditStudentModalOpen: true,
      studentToEdit: player
    });
  };

  openAddStudentModal = () =>
    this.setState({
      isAddStudentModalOpen: true,
      studentToAdd: undefined,
      identicalStudents: [],
      similarStudents: [],
      errorMessage: ''
    });

  closeAddStudentModal = () =>
    this.setState({
      isAddStudentModalOpen: false,
      studentToAdd: undefined,
      identicalStudents: [],
      similarStudents: []
    });

  onSubmitAddStudent = async (
    data: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean
  ): Promise<boolean> => {
    const { user } = this.props;
    const firstName = String(data.firstName || '').trim();
    const lastName = String(data.lastName || '').trim();
    const birthday = data.birthday || '';
    const sameNameCriteria = {
      firstName: { like: firstName, options: 'i' },
      lastName: { like: lastName, options: 'i' }
    };
    const birthdayCriteria = birthday ? { $gte: new Date(birthday), $lte: new Date(birthday) } : undefined;
    const where = birthday
      ? {
          $or: [
            sameNameCriteria,
            { lastName: { like: lastName, options: 'i' }, birthday: birthdayCriteria },
            { firstName: { like: firstName, options: 'i' }, birthday: birthdayCriteria }
          ]
        }
      : sameNameCriteria;

    try {
      const { items: candidates } = await searchSchoolStudents(user, {
        limit: DEFAULT_LIMIT,
        skip: DEFAULT_SKIP,
        where
      });
      const normalizedFirstName = firstName.toLowerCase();
      const normalizedLastName = lastName.toLowerCase();
      const normalizeBirthday = value => String(value || '').slice(0, 10);
      const identicalStudents = candidates.filter(student => {
        return (
          String(student.firstName || '')
            .trim()
            .toLowerCase() === normalizedFirstName &&
          String(student.lastName || '')
            .trim()
            .toLowerCase() === normalizedLastName &&
          normalizeBirthday(student.birthday) === normalizeBirthday(birthday)
        );
      });
      const similarStudents = candidates.filter(student => {
        if (identicalStudents.some(identical => identical.id === student.id)) return false;
        const sameFirstName =
          String(student.firstName || '')
            .trim()
            .toLowerCase() === normalizedFirstName;
        const sameLastName =
          String(student.lastName || '')
            .trim()
            .toLowerCase() === normalizedLastName;
        const sameBirthday = Boolean(birthday) && normalizeBirthday(student.birthday) === normalizeBirthday(birthday);
        return birthday
          ? (sameFirstName && sameLastName) || (sameFirstName && sameBirthday) || (sameLastName && sameBirthday)
          : sameFirstName && sameLastName;
      });

      if (identicalStudents.length > 0 || (similarStudents.length > 0 && !isSavingSimilarStudentConfirmed)) {
        this.setState({ identicalStudents, similarStudents, studentToAdd: data });
        return false;
      }

      const transformedData: any = { ...data, formId: data.form?.id || data.formId || undefined };
      delete transformedData.form;
      if (!transformedData.houseId) delete transformedData.houseId;
      const newStudent = await addSchoolStudent(user, transformedData);
      await updateSchoolTournamentTeamPlayersBatch(user, this.getTournamentId(), this.getTeamId(), {
        add: [{ userId: newStudent.id, permissionId: newStudent.permissionId }],
        remove: []
      });
      await this.setItems();
      this.closeAddStudentModal();
      return true;
    } catch (error) {
      console.error('Error adding student to tournament team:', error);
      this.setState({ errorMessage: 'Failed to add the student. Please try again.' });
      return false;
    }
  };

  renderAddStudentModal() {
    const { isAddStudentModalOpen, studentToAdd, forms, identicalStudents, similarStudents, errorMessage } = this.state;
    if (!isAddStudentModalOpen) return null;
    return (
      <SimpleModal
        isOpen={true}
        title="Add student"
        onCloseClick={this.closeAddStudentModal}
        showFooter={false}
        customClass="tournamentStudentEditModal"
        dialogStyle={{ maxWidth: 680 }}
      >
        {errorMessage && <div className="tournamentStudentEditModal__error">{errorMessage}</div>}
        <StudentForm
          student={studentToAdd || { firstName: '', lastName: '', formId: '' }}
          onSubmit={this.onSubmitAddStudent}
          onCancel={this.closeAddStudentModal}
          user={this.props.user}
          isCreateStudentsChain={false}
          identicalStudents={identicalStudents}
          similarStudents={similarStudents}
          isFormsExist={forms.length > 0}
          isEditStudent={false}
          compact={true}
          fieldsToShow={['firstName', 'lastName', 'gender', 'birthday', 'form']}
        />
      </SimpleModal>
    );
  }

  openEditStudentModal = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 1) {
      this.setState({
        isEditStudentModalOpen: true,
        studentToEdit: selectedItems[0]
      });
    }
  };

  closeEditStudentModal = () => {
    this.setState({
      isEditStudentModalOpen: false,
      studentToEdit: null
    });
  };

  onSubmitEditStudent = async (
    data: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean
  ): Promise<boolean> => {
    const { user } = this.props;
    const { studentToEdit } = this.state;

    if (!studentToEdit) return false;

    const transformedData: any = {
      ...data,
      formId: data.form?.id || null
    };

    if (data.house?.id && /^[a-fA-F0-9]{24}$/.test(data.house.id)) {
      transformedData.houseId = data.house.id;
    } else {
      delete transformedData.houseId;
    }

    try {
      await updateSchoolStudent(user, studentToEdit.userId, transformedData);

      await this.setItems();

      this.closeEditStudentModal();
      return true;
    } catch (error) {
      console.error('Error updating student:', error);
      this.setState({
        errorMessage: 'Failed to update student. Please try again.'
      });
      return false;
    }
  };

  renderEditStudentModal() {
    const { isEditStudentModalOpen, studentToEdit, forms } = this.state;
    const { user } = this.props;
    if (!isEditStudentModalOpen || !studentToEdit) return null;

    return (
      <SimpleModal
        isOpen={isEditStudentModalOpen}
        title="Edit student"
        onCloseClick={() => this.setState({ isEditStudentModalOpen: false, studentToEdit: null })}
        showFooter={false}
        customClass="tournamentStudentEditModal"
        dialogStyle={{ maxWidth: 680 }}
      >
        <StudentForm
          student={studentToEdit}
          onSubmit={this.onSubmitEditStudent}
          onCancel={this.closeEditStudentModal}
          user={user}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={forms && forms.length > 0}
          isEditStudent={true}
          compact={true}
          fieldsToShow={['firstName', 'lastName', 'gender', 'birthday', 'form']}
        />
      </SimpleModal>
    );
  }

  removePlayerFromTeam = (): void => {
    const { user } = this.props;
    const { currentPlayer, selectedItems } = this.state;
    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const playerIdsForRemove = isCurrentPlayerExist ? [currentPlayer.id] : selectedItems.map(item => item.id);

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();
    const removeTeamData = {
      remove: playerIdsForRemove
    };

    this.setState({
      isLoading: true
    });

    updateSchoolTournamentTeamPlayersBatch(user, tournamentId, teamId, removeTeamData)
      .then(() => {
        this.setState({
          isRemoveFromTeamConfirmationModalOpen: false,
          modalText: '',
          isLoading: false,
          currentPlayer: undefined
        });

        this.setItems();
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isRemoveFromTeamConfirmationModalOpen: false,
          actionErrorMessage: getApiErrorMessage(error)
        });
      });
  };

  renderRemoveFromEventConfirmationModal() {
    const { isRemoveFromEventConfirmationModalOpen, isAskToRemovePlayerFromEvent, modalText } = this.state;

    return (
      <SimpleModal
        isOpen={isRemoveFromEventConfirmationModalOpen}
        showHeader={false}
        showFooter={false}
        customClass="tournamentRemovalModal"
        dialogStyle={{ maxWidth: 520 }}
        onBackdropClick={this.closeRemoveFromEventConfirmationModal}
      >
        <div className="tournamentRemovalModal__content">
          <header>
            <span className="tournamentRemovalModal__icon" aria-hidden="true">
              !
            </span>
            <div>
              <h2>Remove from event?</h2>
              <p>This allocation will be removed immediately.</p>
            </div>
            <button type="button" onClick={this.closeRemoveFromEventConfirmationModal} aria-label="Close">
              ×
            </button>
          </header>
          <div className="tournamentRemovalModal__body">
            <p>{modalText}</p>
            <label className="tournamentRemovalModal__remember">
              <input
                type="checkbox"
                checked={isAskToRemovePlayerFromEvent}
                onChange={() =>
                  this.setState(prevState => ({
                    isAskToRemovePlayerFromEvent: !prevState.isAskToRemovePlayerFromEvent
                  }))
                }
              />
              Don’t ask again during this session
            </label>
          </div>
          <footer>
            <button type="button" onClick={this.closeRemoveFromEventConfirmationModal}>
              Cancel
            </button>
            <button type="button" className="isDanger" onClick={this.removePlayerFromEvent}>
              Remove from event
            </button>
          </footer>
        </div>
      </SimpleModal>
    );
  }

  openRemoveFromEventConfirmationModal = (): void => {
    this.setState({
      isRemoveFromEventConfirmationModalOpen: true
    });
  };

  closeRemoveFromEventConfirmationModal = (): void => {
    this.setState({
      isAskToRemovePlayerFromEvent: false,
      isRemoveFromEventConfirmationModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderRemoveFromTeamConfirmationModal() {
    const { isRemoveFromTeamConfirmationModalOpen, modalText, currentPlayer, selectedItems } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const selectedPlayersNames = selectedItems.map(item => getFullName(item)).join(', ');
    const modalBodyText = isCurrentPlayerExist
      ? modalText
      : `${selectedPlayersNames} will be removed from the team. Are you sure?`;

    return (
      <SimpleModal
        isOpen={isRemoveFromTeamConfirmationModalOpen}
        showHeader={false}
        showFooter={false}
        customClass="tournamentRemovalModal"
        dialogStyle={{ maxWidth: 520 }}
        onBackdropClick={this.closeRemoveFromTeamConfirmationModal}
      >
        <div className="tournamentRemovalModal__content">
          <header>
            <span className="tournamentRemovalModal__icon" aria-hidden="true">
              !
            </span>
            <div>
              <h2>Remove from team?</h2>
              <p>The selected players will no longer belong to this tournament team.</p>
            </div>
            <button type="button" onClick={this.closeRemoveFromTeamConfirmationModal} aria-label="Close">
              ×
            </button>
          </header>
          <div className="tournamentRemovalModal__body">
            <p>{modalBodyText}</p>
          </div>
          <footer>
            <button type="button" onClick={this.closeRemoveFromTeamConfirmationModal}>
              Cancel
            </button>
            <button type="button" className="isDanger" onClick={this.removePlayerFromTeam}>
              Remove from team
            </button>
          </footer>
        </div>
      </SimpleModal>
    );
  }

  openRemoveFromTeamConfirmationModal = (): void => {
    this.setState({
      isRemoveFromTeamConfirmationModalOpen: true
    });
  };

  closeRemoveFromTeamConfirmationModal = (): void => {
    this.setState({
      isAskToRemovePlayerFromEvent: false,
      isRemoveFromTeamConfirmationModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderPlayersWithEvents = players => {
    return (
      <ul className="mt-2">
        {players
          .filter(item => {
            const { events } = item;

            return (events || []).length > 0;
          })
          .map(player => {
            const { id } = player;
            const playerFullName = getFullName(player);

            return <li key={id}>{playerFullName}</li>;
          })}
      </ul>
    );
  };

  renderRemoveFromTeamProhibitionModal() {
    const { isRemoveFromTeamProhibitionModalOpen, selectedItems, currentPlayer } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const selectedPlayers = isCurrentPlayerExist ? [currentPlayer] : selectedItems;

    const modalText =
      'You cannot remove the following students as they have been added to some events within the tournament. Please remove them from the events first.';

    return (
      <SimpleModal
        isOpen={isRemoveFromTeamProhibitionModalOpen}
        showHeader={false}
        showFooter={false}
        customClass="tournamentRemovalModal"
        dialogStyle={{ maxWidth: 520 }}
        onBackdropClick={this.closeRemoveFromTeamProhibitionModal}
      >
        <div className="tournamentRemovalModal__content">
          <header>
            <span className="tournamentRemovalModal__icon" aria-hidden="true">
              !
            </span>
            <div>
              <h2>Remove event allocations first</h2>
              <p>These students cannot be removed from the team yet.</p>
            </div>
            <button type="button" onClick={this.closeRemoveFromTeamProhibitionModal} aria-label="Close">
              ×
            </button>
          </header>
          <div className="tournamentRemovalModal__body">
            <p>{modalText}</p>
            {this.renderPlayersWithEvents(selectedPlayers)}
          </div>
          <footer>
            <button type="button" onClick={this.closeRemoveFromTeamProhibitionModal}>
              Close
            </button>
          </footer>
        </div>
      </SimpleModal>
    );
  }

  openRemoveFromTeamProhibitionModal = (): void => {
    this.setState({
      isRemoveFromTeamProhibitionModalOpen: true
    });
  };

  closeRemoveFromTeamProhibitionModal = (): void => {
    this.setState({
      isRemoveFromTeamProhibitionModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderAddPlayerToEventModal() {
    const { user } = this.props;
    const { isAddPlayerToEventModalOpen, selectedItems, currentPlayer } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const students = isCurrentPlayerExist ? [currentPlayer] : selectedItems;
    const tournamentId = this.getTournamentId();

    return (
      <SimpleModal
        isOpen={isAddPlayerToEventModalOpen}
        showHeader={false}
        showFooter={false}
        customClass="eventAllocationModalDialog"
        dialogStyle={{ maxWidth: 1020 }}
        onBackdropClick={() => this.addPlayerToEventFormRef.current?.requestClose()}
      >
        <AddPlayerToEventForm
          ref={this.addPlayerToEventFormRef}
          students={students}
          user={user}
          tournamentId={tournamentId}
          addPlayerToEvent={this.addPlayerToEvent}
          onCloseClick={this.closeAddPlayerToEventModal}
        />
      </SimpleModal>
    );
  }

  openAddPlayerToEventModal = (): void => {
    this.setState({
      isAddPlayerToEventModalOpen: true
    });
  };

  closeAddPlayerToEventModal = (): void => {
    this.setState({
      isAddPlayerToEventModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderGrid() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      forms,
      isSelectAllChecked,
      currentPage,
      total
    } = this.state;
    const { user, history } = this.props;
    const { location } = history;
    const isRosterReadOnly = this.isRosterReadOnly();
    const teamName = propz.get(location, ['state', 'teamName'], '');
    const gridTitle = teamName || (isRosterReadOnly ? 'View participants & allocations' : 'Allocate to events');

    const ageGroupName = propz.get(user, ['activeSchool', 'ageGroupsNaming'], '');

    const selectedPlayersWithEvents = selectedItems.filter(item => {
      const { events } = item;
      return (events || []).length > 0;
    });

    const isSelectedItemsEventsExist = selectedPlayersWithEvents.length > 0;

    const actionItems = isRosterReadOnly ? [] : [
      {
        itemText: '+ Allocate to events',
        onItemClick: this.openAddPlayerToEventModal,
        isActive: selectedItems.length > 0
      },
      {
        itemText: 'Remove from the team',
        onItemClick: isSelectedItemsEventsExist
          ? this.openRemoveFromTeamProhibitionModal
          : this.openRemoveFromTeamConfirmationModal,
        isActive: selectedItems.length > 0,
        isDanger: true
      }
    ];

    const filterOptions = {
      ages: getSelectOptionForAge(forms, ageGroupName),
      gender: getSelectOptionForGender(),
      isRosterReadOnly
    };

    const columns = isRosterReadOnly ? COLUMNS.filter(column => column.field !== 'actions') : COLUMNS;

    return (
      <Grid2
        isActionsInline={true}
        selectionActionsBelow={true}
        showClearSelection={true}
        renderAdditionalOptions={isRosterReadOnly ? undefined : () => (
          <button type="button" className="tournamentTeamPlayersModern__addStudent" onClick={this.openAddStudentModal}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="9" cy="8" r="3.5" />
              <path d="M3.5 20c.4-4 2.2-6 5.5-6s5.1 2 5.5 6M18 8v7m-3.5-3.5h7" />
            </svg>
            Add student
          </button>
        )}
        gridTitleCount={total}
        toolbarSearchField="name"
        toolbarSearchPlaceholder="Search players"
        onToolbarSearchClear={this.onToolbarSearchClear}
        selectedItemsCount={selectedItems.length}
        isCSV={false}
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={columns}
        actionItems={actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onCancelFilterClick={this.onCancelFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        onCellIconClick={this.onCellIconClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
        gridTitle={gridTitle}
        user={user}
        columnVisibilityKey="tournaments.school.teamPlayers"
        fixedColumnFields={['birthday', 'name']}
        hiddenColumnToggleFields={['eventsActions', 'actions']}
        emptyText={isDataFiltered ? 'No players match your filters' : 'No players in this team yet'}
        emptyHint={
          isDataFiltered ? 'Try changing your search or filters.' : 'Add players to build the tournament team.'
        }
      />
    );
  }

  render() {
    const { isLoading, total } = this.state;
    const teamName = propz.get(this.props.location, ['state', 'teamName'], '') || 'Team players';

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="schoolInvitesList tournamentTeamPlayersModern">
        <header className="tournamentListPageHeader">
          <button type="button" onClick={this.goBack}>
            <span aria-hidden="true">←</span> Tournament teams
          </button>
          <i aria-hidden="true" />
          <div>
            <small>Tournament team</small>
            <h1>{teamName}</h1>
          </div>
          <b>{total.toLocaleString()}</b>
        </header>
        {this.renderAddPlayerToEventModal()}
        {this.renderRemoveFromEventConfirmationModal()}
        {this.renderRemoveFromTeamConfirmationModal()}
        {this.renderRemoveFromTeamProhibitionModal()}
        {this.renderAddStudentModal()}
        {this.renderEditStudentModal()}
        {this.renderActionErrorModal()}
        <div>{this.renderGrid()}</div>
      </div>
    );
  }
}
